import { Analytics } from './analytics';

if(document.getElementById("404-page")) {
    Analytics.sendRawEvent({
        "event": "error",
        "interaction": {
          "error_type": "404",
          "error_referrer": document.location.hostname
        }
    });
}